import Vue from 'vue';
import './layout.scss';
import layoutBase from '../layout-base';
import mhsh from '../../modules/MHSH/mhsh';
import VueGallery from '@ui-common/vue-gallery';
new Vue({ extends: layoutBase, components: { mhsh, VueGallery } }).$mount('[data-layout-id="AHAL-app"]');
